"use strict";

var _notify = require("linksoft/notify");

var _notify2 = _interopRequireDefault(_notify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var $ = require("jquery");
var discountService = abp.services.api.discount;

module.exports = exports.default = function () {
    $("#discountsSubmit").off("click").on("click", function () {
        var productId = $("#Id").val();
        // TODO: do not use UTC time
        var date = $("#Date").val() == "" ? new Date().toISOString().slice(0, 19) : new Date($("#Date").val()).toISOString().slice(0, 19);
        var loyaltyProgramId = $("#LoyaltyProgramId").val();
        var coupon = $("#Coupon").val();
        var customerCard = $("#CustomerCard").select2("data")[0].id || null;
        var amount = $("#Amount").val() || 1;

        $("#appliedDiscounts").DataTable().query(function (x) {
            x.date = date, x.loyaltyProgramId = loyaltyProgramId, x.coupon = coupon, x.customerCard = customerCard, x.amount = amount;
        });
        $("#appliedDiscounts").DataTable().ajax.reload(null, false);
        // TODO JNI PRICES GetCartPriceForOneProduct
        discountService.getCataloguePrices(productId, amount, null, loyaltyProgramId, customerCard, date, coupon).done(function (result) {
            var finalPrice = result;
            $("#finalPrice").html(finalPrice);
        }).fail(function (err) {
            _notify2.default.error(err.responseJSON.message);
        });
    });
};


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/appliedDiscounts.js
// module id = 410
// module chunks = 0